import { toast } from "react-toastify";

import { OrganizationDto, PatchConfigurationDto } from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { organizationsKeys } from "../queryKeys";

export const patchConfigurations = async (
  configurations: PatchConfigurationDto[]
): Promise<OrganizationDto> => {
  const resp = await api.patch<OrganizationDto>(
    "/v2/organizations/configurations",
    configurations
  );
  return resp.data;
};

export const usePatchConfigurations = (noToast?: boolean) => {
  const queryClient = useQueryClient();
  return useMutation<OrganizationDto, Error, any, any>({
    mutationKey: ["updateConfiguration"],
    mutationFn: async (data: PatchConfigurationDto[]) =>
      patchConfigurations(data),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: organizationsKeys.one });
      void queryClient.invalidateQueries({
        queryKey: organizationsKeys.cartTransforms(data.id),
      });
      void queryClient.invalidateQueries({
        queryKey: organizationsKeys.metafield(data.id),
      });
      void queryClient.invalidateQueries({
        queryKey: organizationsKeys.cartTransforms(data.id),
      });
      if (!noToast) {
        toast.success("Configuration Update Successful!");
      }
    },
  });
};
